module.exports = __webpack_public_path__ + "img/CAN.30475c03.svg";